<div class="pointer-events-none fixed top-4 right-4 z-[2147483647]">
    <div class="flex flex-col gap-3 w-full max-w-md">
        @for (toast of toasts; track toast.id) {
        <div class="pointer-events-auto">
            <div class="flex items-center gap-4 rounded-lg bg-white p-3 py-4 shadow-lg
                   transition-all duration-200 border-l-[3px] transform" [ngClass]="[
                isVisible(toast.id)
                  ? 'opacity-100 translate-y-0 scale-100'
                  : 'opacity-0 translate-x-100 scale-95',
                getBorderLeftClass(toast.type)
            ]">
                <!-- Left icon -->
                <div class="flex h-4 w-4 items-center justify-center rounded-full border-2 flex-shrink-0"
                    [ngClass]="getIconRingClass(toast.type)">
                    <i class="bi text-sm" [ngClass]="getIconClass(toast.type)"></i>
                </div>

                <!-- Text area -->
                @if (toast.title) {
                <!-- Title + description stacked -->
                <div class="flex-1">
                    <p class="text-base font-semibold leading-snug">
                        {{ toast.title }}
                    </p>
                    @if (toast.message) {
                    <p class="text-sm leading-snug mt-0.5">
                        {{ toast.message }}
                    </p>
                    }
                </div>
                } @else {
                <!-- No title: icon + description horizontally aligned -->
                <div class="flex-1 flex items-center">
                    <p class="text-sm leading-snug">
                        {{ toast.message }}
                    </p>
                </div>
                }

                <!-- Close button (circular) -->
                <button type="button" class="flex h-5 w-5 items-center justify-center rounded-full
                     bg-gray-100 text-xs text-gray-500 hover:bg-gray-200 hover:text-gray-700
                     transition-colors" (click)="onManualClose(toast.id, $event)">
                    <i class="bi bi-x-circle-fill"></i>
                </button>
            </div>
        </div>
        }
    </div>
</div>